module.exports = "/_next/static/images/03b9a78c424f13b474f0d48cd3602a41-invite-icon.svg";